// extracted by mini-css-extract-plugin
module.exports = {"video":"Calibration_video__2k7Wz","videoPlayerHidden":"Calibration_videoPlayerHidden__1orF4"};